import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Grid, Button, Paper, Container, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import emailOutline from '@iconify/icons-eva/email-outline';
import phoneOutline from '@iconify/icons-eva/phone-outline';
import homeOutline from '@iconify/icons-eva/home-outline';
import { ContactForm } from '../components/_dashboard/user';
import { termsData } from '../DATA/DataText';

const useStyles = makeStyles((theme) => ({
  backgroundFix: {
    position: 'relative',
    height: '200px',
    marginTop: 120,
    width: '100%',
    backgroundColor: '#F78181',
    backgroundAttachment: 'fixed',
    zIndex: 2
  },
  centerTitleContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white',
      fontFamily: 'Open Sans, sans-serif'
    }
  },
  centerTitle: {
    width: 400,
    height: 150,
    backgroundColor: 'transparent',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    '& h1': {
      fontSize: '37px',
      fontWeight: 500,
      color: 'white'
    },
    '& h3': {
      fontSize: '20px',
      fontWeight: 500,
      color: 'white',
      marginTop: 15
    }
  },
  gridContainer: {
    // backgroundColor: 'pink',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 50,
    marginTop: 100
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '2rem',
    color: 'black',
    marginTop: 10,
    fontFamily: 'Open Sans, sans-serif'
  },
  title: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '1.8rem',
    fontWeight: 700,
    color: 'black',
    marginBottom: 10
  },
  title1: {
    fontFamily: 'Open Sans, sans-serif',
    fontSize: '0.9rem',
    fontWeight: 700,
    color: 'black',
    lineHeight: '50px',
    marginBottom: 10
  },
  list: {
    '& li': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '2rem',
      color: 'black',
      marginTop: 10,
      fontFamily: 'Open Sans, sans-serif'
    }
  }
}));

const ConditionGenerale = () => {
  const classes = useStyles();
  const [t, i18n] = useTranslation();

  return (
    <div>
      <Grid container xs={12} className={classes.backgroundFix}>
        <Box className={classes.centerTitleContainer}>
          <h1>{t('conditions_Générales')}</h1>
        </Box>
      </Grid>
      <Container maxWidth="md" style={{ marginBottom: 200 }}>
        <Grid container xs={12} className={classes.gridContainer}>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.text}>
              {t('Afin_de_pouvoir_utiliser_le_site')}
            </Typography>
            <Typography className={classes.text}>{t('Les_présentes_conditions')}</Typography>
            <Typography className={classes.text}>{t('SmileLand_se_réserve')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>1. {t('Définitions')}</Typography>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Login')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Cette_section_concerne')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Contact')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Contact_desc')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('À_propos')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('À_propos_desc')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Accueil')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Accueil_desc1')}
              </Typography>
              <Typography className={classes.text}>{t('Accueil_desc2')}</Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Contenu')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Contenu_desc')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Editeur')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Editeur_desc')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Site_internet')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Site_internet_desc')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Utilisateur')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Utilisateur_desc')}
              </Typography>
            </Box>
            <Box>
              <Typography className={classes.title1} display="inline">
                {t('Visiteur')} :{'  '}
              </Typography>
              <Typography className={classes.text} display="inline">
                {t('Visiteur_desc')}
              </Typography>
            </Box>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>2. {t('Accès_au_site')}</Typography>
            <Typography className={classes.text}>{t('accès_au_site_est_réservé')}</Typography>
            <Typography className={classes.title1}>
              {t('Pour_les_cherches')} :{'  '}
            </Typography>
            <Typography className={classes.text}>{t('Vous_êtes_seul')}</Typography>
            <Typography className={classes.text}>{t('Vous_vous_engagez')}</Typography>
            <Typography className={classes.text}>{t('accès_non_autorisé')}</Typography>
            <Typography className={classes.text}>{t('Vous_vous_engagez_à_bénéficier')}</Typography>
            <Typography className={classes.text}>{t('Vous_vous_engagez_à_utiliser')}</Typography>
            <Typography className={classes.title1}>
              {t('Résiliation_de_Service')} :{'  '}
            </Typography>
            <Typography className={classes.text}>{t('SmileLand_se_réserve_le')}</Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('comportement_susceptible')}</li>
              <li>{t('Mener_une_activité')}</li>
              <li>{t('En_cas_de_litige')}</li>
              <li>{t('Suspension_temporaire')}</li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              3. {t('Inscrivezvous_sur_application')}
            </Typography>
            <Typography className={classes.text}>{t('La_condition_pour_saisir')}</Typography>
            <Typography className={classes.text}>
              {t('Pour_accéder_à_application_Smileland')}
            </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('Saisissez_votre_adresse')}</li>
              <li>{t('Définissez_un_mot_de_passe_sécurisé')}</li>
            </ul>
            <Typography className={classes.title1}>
              {t('Les_fonctionnalités_disponibles')} :{'  '}
            </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('Gestion_du_compte_et_informations')}</li>
              <li>{t('Choisissez_la_crèche_et_la_classe')}</li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              4. {t('Application_Educatrice_SmileLand')}
            </Typography>
            <Typography className={classes.text}>{t('Les_éducatrices_travaillant')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>5. {t('Inscrivezvous_s_application')}</Typography>
            <Typography className={classes.text}>
              {t('connexion_à_application_SmileLand')}
            </Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>6. {t('Contenu_du_site_Web')}</Typography>
            <Typography className={classes.text}>{t('Toutes_les_marques')}</Typography>
            <Typography className={classes.text}>{t('LesiteWebet_les_applications')}</Typography>
            <Typography className={classes.text}>{t('Lesvisiteursconsultent')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>
              7. {t('Accessibilitégestion_du_site')}
            </Typography>
            <Typography className={classes.text}>{t('Ce_site_est_accessible24')}</Typography>
            <Typography className={classes.text}>{t('Pour_raisons_demaintenance')}</Typography>
            <Typography className={classes.text}>{t('Les_cookies_déposés')}</Typography>
            <Typography className={classes.text}>
              {t('Pour_bonneadministration')} :{'  '}
            </Typography>
            <ul
              className={classes.list}
              style={{
                padding: document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px'
              }}
            >
              <li>{t('Suspendre_interrompre')}</li>
              <li>{t('Suspendre_interromprerestreindre')}</li>
              <li>{t('Suspendre_misesjour')}</li>
              <li>{t('Bloquer_accèsdésinscrire')}</li>
            </ul>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>8. {t('Responsabilité_garanties')}</Typography>
            <Typography className={classes.text}>{t('Malgré_tout_la_concentration')}</Typography>
            <Typography className={classes.text}>{t('LasociétéSmileLandgarantit')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>9. {t('Termesconditions')}</Typography>
            <Typography className={classes.text}>{t('EnaucuncasSmile')}</Typography>
            <Typography className={classes.text}>{t('Lesinformationssurcesite')}</Typography>
            <Typography className={classes.text}>{t('Lesitepeutcontenir')}</Typography>
            <Typography className={classes.text}>{t('SmileLandaucun')}</Typography>
            <Typography className={classes.text}>{t('LesapplicationsSmile')}</Typography>
            <Typography className={classes.text}>{t('Ilesttenuutiliser')}</Typography>
            <Typography className={classes.text}>{t('Ilestinterditutiliser')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>10. {t('Renseignementspersonnels')}</Typography>
            <Typography className={classes.text}>{t('Pourtouteinformation')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>11. {t('XICookies')}</Typography>
            <Typography className={classes.text}>{t('Diversesinformations')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>12. {t('XIIDroitapplicable')}</Typography>
            <Typography className={classes.text}>{t('Lesprésentesconditions')}</Typography>
          </Box>
          <Box style={{ marginBottom: 30 }}>
            <Typography className={classes.title}>13. {t('XIIIContactez-nous')}</Typography>
            <Typography className={classes.text}>
              {t('Pourtoutequestion')}
              <font color="blue">: smileland@gmail.com.</font>
            </Typography>
          </Box>
        </Grid>
      </Container>
    </div>
  );
};

export default ConditionGenerale;
